/* Progressive collection browsing: normal next-page links remain the fallback. */
if (!customElements.get('zen-load-more')) {
  customElements.define('zen-load-more', class extends HTMLElement {
    connectedCallback() {
      this.link = this.querySelector('[data-load-next]');
      this.status = this.querySelector('[role="status"]');
      this.controller = new AbortController();
      this.link?.addEventListener('click', event => {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        this.load(false);
      }, { signal: this.controller.signal });
      this.querySelector('[data-pagination-fallback]')?.setAttribute('hidden', '');
      if ('IntersectionObserver' in window && this.link) {
        this.observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) this.load(true);
        }, { rootMargin: '600px 0px' });
        this.observer.observe(this);
      }
    }
    disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); }
    async load(automatic = false) {
      if (this.busy || !this.link) return;
      this.busy = true;
      this.observer?.unobserve(this);
      const grid = this.closest('#ProductGridContainer')?.querySelector('ul#product-grid');
      if (!grid) { location.assign(this.link.href); return; }
      const nextURL = this.link.href;
      this.link.setAttribute('aria-disabled', 'true');
      this.link.textContent = 'Loading…';
      this.status.textContent = 'Loading more products';
      try {
        const response = await fetch(nextURL, { signal: this.controller.signal });
        if (!response.ok) throw new Error('Page unavailable');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const nextGrid = doc.querySelector('ul#product-grid');
        const nextControl = doc.querySelector('zen-load-more');
        if (!nextGrid || !nextControl) throw new Error('Missing product grid');
        if (!this.isConnected) return;
        const added = [...nextGrid.children];
        const firstProduct = added.find(el => !el.classList.contains('zen-editorial-tile'));
        grid.append(...added);
        this.querySelector('[data-browse-count]').textContent = nextControl.querySelector('[data-browse-count]').textContent;
        const nextLink = nextControl.querySelector('[data-load-next]');
        if (nextLink) {
          this.link.href = nextLink.href;
          this.link.textContent = 'Load more';
          this.link.removeAttribute('aria-disabled');
        } else {
          this.link.remove();
          this.link = null;
        }
        this.status.textContent = `${added.filter(el => !el.classList.contains('zen-editorial-tile')).length} more products loaded`;
        const target = firstProduct?.querySelector('a[id^="CardLink-"]');
        if (!automatic && target) { target.focus({ preventScroll: true }); firstProduct.scrollIntoView({ block: 'start', behavior: 'instant' }); }
        this.querySelector('[data-pagination-fallback]')?.setAttribute('hidden', '');
        if (this.link) this.observer?.observe(this);
        else this.observer?.disconnect();
      } catch (error) {
        if (error.name !== 'AbortError' && this.isConnected) {
          this.status.textContent = 'Could not load more products. Please try again or open the next page.';
          this.link.textContent = 'Try again';
          this.link.removeAttribute('aria-disabled');
          this.querySelector('[data-pagination-fallback]')?.removeAttribute('hidden');
        }
      } finally { this.busy = false; }
    }
  });
}
